import { createCommand } from '@commander-js/extra-typings';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { schemaGenerateExtensionsCommand } from './schema-generate-extensions.js';

export const schemaCommand = (
  services: AstroCommandServices,
  cliVersion: string
) =>
  createCommand('schema')
    .description('Print machine-readable schemas for CLI commands')
    .addCommand(schemaGenerateExtensionsCommand(services, cliVersion));
